export * from './besichtigung-post-request.interface';
export * from './besichtigung-post-response.interface';
export * from './besichtigung-post.shapes';
